import { DataTable, Dialog } from "@/components";
import { PropertyDialogProps } from "./types";
import usePropertyDialog from "./usePropertyDialog";

const PropertyDialog = ({
  open,
  setOpen,
  selectedRow,
}: PropertyDialogProps) => {
  const { columns } = usePropertyDialog({ selectedRow });
  return (
    <Dialog
      open={open}
      setOpen={setOpen}
      title={<div className="text-2xl font-bold text-primary">
          {`Associated Properties - ${selectedRow?.ownerName}`}
          <div className="h-1 w-[30%] bg-primary rounded-full" />
        </div>
      }
      contentClassName="lg:!max-w-[700px] lg:!w-[700px]"
    >
      <DataTable
        columns={columns}
        data={selectedRow?.properties || []}
        hideFooter
        className="shadow-none border-0"
        tableWrapperClassName="p-0"
      />
    </Dialog>
  )
}

export default PropertyDialog;